import { render } from "./business-info.vue?vue&type=template&id=c55d1a2e&scoped=true"
import script from "./business-info.vue?vue&type=script&lang=js"
export * from "./business-info.vue?vue&type=script&lang=js"

import "./business-info.vue?vue&type=style&index=0&id=c55d1a2e&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55d1a2e"]])

export default __exports__